import React, { useState } from 'react';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import { categories, actions } from '../../helpers/analytics-utils/constants';
import FiltersLarge from './filters-large';
import FiltersSmall from './filters-small';
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = _ref => {
  let {
    children,
    count
  } = _ref;
  const {
    0: expanded,
    1: expand
  } = useState(false);
  const formattedCountDisplay = String(count);
  const clickHandle = () => {
    expand(!expanded);
    trackClickEvent(categories.WHATS_HAPPENING_FILTERS, expanded ? actions.COLLAPSE_FILTERS : actions.EXPAND_FILTERS, undefined);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.evolved,
    "data-id": "whats-happening-filters_wrapper_Wrapper_div",
    children: [/*#__PURE__*/_jsx(FiltersLarge, {
      countDisplay: formattedCountDisplay,
      "data-id": "whats-happening-filters_wrapper_Wrapper_div_FiltersLarge",
      children: children
    }), /*#__PURE__*/_jsx(FiltersSmall, {
      countDisplay: formattedCountDisplay,
      onClick: clickHandle,
      "data-id": "whats-happening-filters_wrapper_Wrapper_div_FiltersSmall",
      children: children
    })]
  });
};
export default Wrapper;